export default __webpack_public_path__ + "static/media/about_m.acb58546.jpg";